import { render, staticRenderFns } from "./AdminEvaluation.vue?vue&type=template&id=ccea743c&"
import script from "./AdminEvaluation.vue?vue&type=script&lang=js&"
export * from "./AdminEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports